import SelectComponent, {SelectComponentComponentProps, SelectComponentReduxProps} from "../../ui/select/SelectComponent";
import {RootState} from "../../../store/reducer/root/RootState";
import * as React from "react";
import {connect} from "react-redux";
import User from "../../../model/user/User";
import {Option} from "ts-option";
import OptionUtils from "../../../utils/OptionUtils";

interface Props {
	/**
	 * Partner brand Id
	 */
	partnerBrandId: Option<string>
	/**
	 * Brand Id
	 */
	brandId: Option<string>
}

class SelectJobAppointmentAssignees extends SelectComponent<User, Props> {
	matchFilter(element: User, filter: string): boolean {
		return element.searchString.indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: User): string {
		return element.id;
	}

	elementToString(element: User) {
		return element.getDisplayName(true);
	}

	onInputChange(value: string) {
		this.props.onInputChange(value);
	}

	getDropdownList(): Option<User[]> {
		return this.props.items.map(list => list.filter(u => !u.disabled));
	}
}

function mapStateToProps(state: RootState, props: Props & SelectComponentComponentProps<User>) {
	return {
		items: state.user.users.map(users => users
			.filter(u => (u.isSalesEngineer()
				|| (u.isThirdPartyEngineer()
					&& OptionUtils.isTheSame(u.data.partnerBrandId, props.partnerBrandId)
					&& OptionUtils.isTheSame(u.data.brandId, props.brandId))
				|| u.id == props.selectedId.orNull))
			.sort(User.compare))
	}
}

export default connect<SelectComponentReduxProps<User>, SelectComponentComponentProps<User>, Props>(mapStateToProps)(
	SelectJobAppointmentAssignees)